import firebase from 'firebase';

import View from '../../_components/view/view.js';
import groupsTpl from './groups.tpl.html';
import './groups.styles.less';

import GroupView from './group/group.view.js';

class GroupsView extends View {

	constructor (data, options) {
		super(groupsTpl, data, options);

		this.groupViews = [];
		this.groupsRef = firebase.database().ref('groups/');
	}

	uiElements() {
		return _.extend(super.uiElements(), {
			btnAddGroup: '.btn-add-group',
			inputName: 'input[name="name"]',
			inputRank: 'input[name="rank"]',
			groupsList: '.groups-list'
		});
	}

	render(data) {
		super.render(data);
		this.initializeGroupsData();
	}

	initializeEvents() {
		this.ui.btnAddGroup.click(() => this.addGroup());
	}

	initializeGroupsData() {
		this.groupsRef.on('value', __groups => {
			this.updateGroupsList(__groups);
		});
	}

	updateGroupsList(__groups) {
		this.removeGroupsList();

		__groups.forEach( __group => {
			let	groupView = new GroupView(__group.val(), {__group: __group});
			this.groupViews.push(groupView);
			groupView.appendTo(this.ui.groupsList);
		});
	}

	removeGroupsList() {
		_.forEach(this.groupViews, groupView => {
			groupView.remove();
		});

		this.groupViews = [];
	}

	addGroup() {
		firebase.database().ref('groups/').push({
			name: this.ui.inputName.val(),
			rank: this.ui.inputRank.val()
		})
		.then(() => this.cleanForm());
	}

	cleanForm() {
		this.ui.inputName.val('');
		this.ui.inputRank.val('');
	}


	/*onShow() {

	}*/


	remove() {
		super.remove();
	}

}

export default GroupsView;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/admin-section/groups/groups.view.js